import {RFI} from "../../../services";
import {FileController} from "../../Boilerplate/FileController";

const docKey = ['match', 'params', 'id'];
const subDocKey = ['match', 'params', 'rfiId'];
const indexType = 'projectrfi';
const topLevelName = 'RFI';

export const RfiFiles = FileController(RFI, indexType, docKey, subDocKey, topLevelName);



// WEBPACK FOOTER //
// ./src/components/Projects/Rfis/RfiFiles.js